import { ApolloLink, Observable } from "apollo-link";
import { beginPendingTask } from "@dhn/shared/pending-tasks";

const isQueryOperation = (operation) =>
  operation.query.definitions.some(
    (definition) =>
      definition.kind === "OperationDefinition" &&
      definition.operation === "query",
  );

// Cuenta las consultas en vuelo; las mutaciones no bloquean la navegación.
const trackPendingQueriesLink = new ApolloLink((operation, forward) => {
  if (!isQueryOperation(operation)) return forward(operation);

  return new Observable((observer) => {
    const finishTask = beginPendingTask("query");
    const subscription = forward(operation).subscribe({
      next: (result) => observer.next(result),
      error: (error) => {
        finishTask();
        observer.error(error);
      },
      complete: () => {
        finishTask();
        observer.complete();
      },
    });

    return () => {
      finishTask();
      subscription.unsubscribe();
    };
  });
});

export default trackPendingQueriesLink;
